import React from 'react';
import styled from 'styled-components';

const HeroBannerWrapper = styled.div`
	color: #fff;
	text-align: center;
	position: sticky;
	z-index: 11;

	.nav-list--item span {
		position: relative;
		&::before {
			background-color: #fff;
		}
	}
`;

const HeroAppNav = styled.div`
	position: absolute;
	width: 100%;
    z-index: 9999;
`;

const HeroBannerImage = styled.div`
	background: url('/assets/images/hero-impact.jpeg') no-repeat;
	background-size: cover;
	background-position: center;
	height: 100vh;
	width: 100%;
	display: grid;
	place-items: center;
	top: 0;

	@media screen and (min-width: 640px) {
		background-position: left;
	}
`;

const HeroOverlay = styled.div`
    display: grid;
    place-items: center;
    width: 100%;
    z-index: 1;
    left: 0;
    top: 0;
    overflow-x: hidden;
    background-color: rgba(0, 0, 0, .35);
    min-height: 100vh;
`;

const BannerText = styled.div`
	h1 {
		text-transform: uppercase;
	}

	h4 {
		padding-top: 15px;
	}
`;

const ExploreButton = styled.small`
	font-size: 13px;
	display: inline-block;
	text-transform: uppercase;
	position: absolute;
	bottom: 80px;
	left: 0;
	right: 0;
	margin: auto;
	letter-spacing: 6px;
    z-index: 9;

	&:after {
		content: '';
		display: block;
		background-color: #fff;
		width: 0.03em;
		height: 40px;
		left: 0;
		right: 0;
		position: absolute;
		margin: 15px auto 0;
		animation: animate 2s infinite;
	}

	@keyframes animate {
		from {
			height: 0px;
		}
		to {
			height: 40px;
		}
	}
`;

const HeroBanner = ({children}) => {
	return (
		<HeroBannerWrapper id="impact-hero">
			<HeroAppNav>{children}</HeroAppNav>
			<HeroBannerImage>
                <HeroOverlay>
                    <BannerText>
                        <h1>Our Impact Story:</h1>
                        <h3>A look at what we achieved</h3>
                    </BannerText>
                </HeroOverlay>
			</HeroBannerImage>
			<ExploreButton>Scroll to Explore</ExploreButton>
		</HeroBannerWrapper>
	);
};

export default HeroBanner;
